import { render, staticRenderFns } from "./LogiAuthorization.vue?vue&type=template&id=4d392660&"
import script from "./LogiAuthorization.vue?vue&type=script&lang=js&"
export * from "./LogiAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports